import React from 'react'
import Ecom from './Ecom/App'
const App = () => {
  return (
    <div>
      <Ecom/>
    </div>
  )
}

export default App
